import React from 'react';

import moment from 'moment';
import styled from 'styled-components';

const SurveyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;
  gap: 10px;

  .surveyValue {
    white-space: nowrap;
    padding: 10px;
    background-color: rgba(43, 61, 84, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 8px;
    color: ${(props) => props.theme.colors['dark-two']};
    width: 50px;
    height: 50px;
  }

  .surveyContent {
    display: grid;
    line-height: 20px;

    @media (min-width: 845px) {
      line-height: 15px;
      gap: 6px;
    }
  }

  .surveyText {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
  }

  .surveyTitle {
    display: flex;
    flex-direction: row;
  }

  .surveySub {
    font-size: 16px;
    white-space: nowrap;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .surveyDate {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }
`;

const Survey = ({ note_filtered, date, wine_name, vintage, journal_name }) => (
  <SurveyContainer>
    <div className="surveyValue">{note_filtered}</div>
    <div className="surveyContent">
      <div>
        <p className="surveyText">{journal_name}</p>
      </div>
      <div>
        <p className="surveySub">{`${wine_name} ${vintage}`}</p>
      </div>
      <div>
        <p className="surveyDate"> {moment(date).format('DD/MM/YYYY')}</p>
      </div>
    </div>
  </SurveyContainer>
);

export default Survey;
